import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent, DialogTitle,
    Typography,
} from '@mui/material';
import React, {
    Dispatch, SetStateAction,
} from 'react';
import DeleteIcon from '../../../../assets/deleteIcon.svg';
import DeleteRowModelStyle from './DeleteRowModel.style';

interface InviteProps {
    open: boolean,
    setOpenDelRow: Dispatch<SetStateAction<boolean>>,
    deleteAction: () => void,
    orgName?: string,
    title?:string,
}

function DeleteRowModel({
    open, setOpenDelRow, deleteAction, orgName, title,
}: InviteProps) {
    const classes = DeleteRowModelStyle();

    const handleClose = () => {
        setOpenDelRow(false);
    };

    return (
        <Box>
            <Dialog fullWidth className={classes.mainDilogBoxSection} open={open}>
                <DialogTitle className={classes.dilogBoxSection}>
                    Delete
                    {' '}
                    {title || 'Rows'}
                </DialogTitle>
                <DialogContent className={classes.dialogBody}>
                    <Box className={classes.centerBody}>
                        <Box className={classes.projectListMain}>
                            <img src={DeleteIcon} alt="graph" />
                        </Box>
                        <Typography className={classes.subHeader} variant="h3">
                            { orgName
                                ? `Are you sure you want to delete the ${title?.toLocaleLowerCase() || ''} '${orgName}'?`
                                : 'Are you sure you want to delete the selected items?'}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions className={classes.dilogBoxSectionFooter}>
                    <Box className={classes.outlineButton}>
                        <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    </Box>
                    <Box className={classes.filledrmButton}>
                        <Button variant="contained" color="primary" onClick={deleteAction}>
                            Delete
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default DeleteRowModel;
